export const CUSTOM_DOMAIN = {
  DPD_UK_DEV: "dpduk.dev",
  DPD_CO_UK: "dpd.co.uk",
  DPD_LOCAL_CO_UK: "dpdlocal.co.uk",
};

export const LOCAL_STORAGE_THEME_NAME_KEY = "mydpd-ui/local";

export const CUSTOM_DOMAIN_LIST = Object.values(CUSTOM_DOMAIN);
